export default __webpack_public_path__ + "static/media/AboutMoniqueDiagram.61779e46.png";